import React, { useState, useRef } from 'react';

const DraggableList = ({ items, renderItem, onReorder, itemKey = 'id' }) => {
  const [draggedItem, setDraggedItem] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const listRef = useRef(null);

  // Start dragging
  const handleDragStart = (e, item, index) => {
    // Set data transfer for Firefox
    e.dataTransfer.setData('text/plain', index);
    // Set dragged item
    setDraggedItem(item);
    // Add dragging class to the dragged element
    e.currentTarget.classList.add('dragging');
    // Set drag effect
    e.dataTransfer.effectAllowed = 'move';
  };

  // Handle drag over
  const handleDragOver = (e, index) => {
    e.preventDefault();
    // Set drag over index
    setDragOverIndex(index);
    // Set drop effect
    e.dataTransfer.dropEffect = 'move';
  };

  // Handle drag end
  const handleDragEnd = (e) => {
    // Remove dragging class
    e.currentTarget.classList.remove('dragging');
    // Reset dragged item and drag over index
    setDraggedItem(null);
    setDragOverIndex(null);
  };

  // Handle drop
  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    
    if (draggedItem) {
      // Find the index of the dragged item
      const dragIndex = items.findIndex(item => item[itemKey] === draggedItem[itemKey]);
      
      // If the indices are the same, do nothing
      if (dragIndex === dropIndex) {
        return;
      }
      
      // Create a new array with the reordered items
      const newItems = [...items];
      
      // Remove the dragged item
      const [removed] = newItems.splice(dragIndex, 1);

      // Adjust drop index after removal when dragging downward
      let insertIndex = dropIndex;
      if (dragIndex < dropIndex) {
        insertIndex -= 1;
      }
      
      // Insert the dragged item at the drop index
      newItems.splice(insertIndex, 0, removed);
      
      // Call the onReorder callback with the new array
      onReorder(newItems);
    }
    
    // Reset dragged item and drag over index
    setDraggedItem(null);
    setDragOverIndex(null);
  };

  return (
    <div className="draggable-list" ref={listRef}>
      {items.map((item, index) => (
        <React.Fragment key={item[itemKey]}>
          {dragOverIndex === index && draggedItem && draggedItem[itemKey] !== item[itemKey] && (
            <div className="drop-indicator"></div>
          )}
          <div
            className={`draggable-item ${draggedItem && draggedItem[itemKey] === item[itemKey] ? 'dragging' : ''}`}
            draggable
            onDragStart={(e) => handleDragStart(e, item, index)}
            onDragOver={(e) => handleDragOver(e, index)}
            onDragEnd={handleDragEnd}
            onDrop={(e) => handleDrop(e, index)}
          >
            {renderItem(item, index)}
          </div>
          {dragOverIndex === items.length - 1 && index === items.length - 1 && draggedItem && draggedItem[itemKey] !== item[itemKey] && (
            <div className="drop-indicator"></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default DraggableList;